import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import i18n from 'i18n-react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import APIHandler from 'config/APIHandler';
import { useSettings } from 'hooks/useSettings';
import { useUserInfo } from 'hooks/useUserInfo';
import { name } from 'settings';

const DiplomaView = () => {
  const { appId, loaded: settingsLoaded } = useSettings();
  const { user, loaded: userInfoLoaded } = useUserInfo();
  const printRef = useRef();

  const { first_name: firstName = '', last_name: lastName = '' } = user || {};

  if (!settingsLoaded || !userInfoLoaded) return null;

  const image = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}`;
  const subject = encodeURIComponent(`${name} diploma`);
  const body = encodeURIComponent(image);
  const downloadName = `${name} Diploma ${firstName} ${lastName}`.replaceAll('&', 'and');

  return (
    <div className="contentContainer diplomaView">
      <div ref={printRef} className="diplomaView__image-wrapper">
        <img
          src={image}
          alt={`${firstName} ${lastName}`}
        />
      </div>
      <div className="buttons__diploma">
        <ReactToPrint
          content={() => printRef.current}
          trigger={() => (
            <div className="fancybox-share__button fancybox-share__button--fb">
              <FontAwesomeIcon icon={['fas', 'print']} />
              <span> {i18n.translate('reportCard.print')}</span>
            </div>
          )}
        />
        <a
          href={`mailto:?subject=${subject}&body=${body}`}
          className="fancybox-share__button fancybox-share__button--pt"
        >
          <FontAwesomeIcon icon={['fas', 'at']} />
          <span>{i18n.translate('reportCard.email')}</span>
        </a>
        <a
          href={APIHandler.getDownloadURL(image, downloadName)}
          className="fancybox-download__button fancybox-download__button--pt"
        >
          <FontAwesomeIcon icon={['fas', 'download']} />
          <span>{i18n.translate('reportCard.download')}</span>
        </a>
      </div>
    </div>
  );
};

export default DiplomaView;
